import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { logAdminError } from '../utils/adminDebug';

type Props = { children: React.ReactNode };
type State = { error: Error | null };

export class AdminErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    logAdminError('React render error', error, { componentStack: info.componentStack });
  }

  render() {
    if (this.state.error) {
      return (
        <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center" p={2}>
          <Paper sx={{ p: 3, maxWidth: 560 }}>
            <Typography variant="h6" color="error" gutterBottom>
              Admin app error
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}>
              {this.state.error.message}
            </Typography>
            <Button
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => this.setState({ error: null })}
            >
              Retry
            </Button>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 2 }}>
              Open DevTools → Console and filter for [admin-web]
            </Typography>
          </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}
